import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../sections/Hero";
import Marquee from "../components/Marquee";
import EnquiryForm from "../sections/EnquiryForm";
import AboutSection from "../sections/AboutSection";
import ServicesSection from "../sections/ServicesSection";
import CountriesSection from "../sections/CountriesSection";
import WhyChoose from "../sections/WhyChoose";
import HowItWorks from "../sections/HowItWorks";
import EligibilitySection from "../sections/EligibilitySection";
import StoriesSection from "../sections/StoriesSection";
import StatsSection from "../sections/StatsSection";
import DocChecklist from "../sections/DocChecklist";
import FaqSection from "../sections/FaqSection";
import BlogPreview from "../sections/BlogPreview";
import ContactSection from "../sections/ContactSection";
import { usePageMeta, scrollToSection } from "../lib/motion";

const Home = () => {
  usePageMeta(
    "",
    "The Trip World provides professional immigration and visa consultancy services including work permit, visitor visa, student visa and documentation assistance."
  );
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(() => scrollToSection(location.state.scrollTo), 400);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <EnquiryForm />
      <AboutSection />
      <ServicesSection />
      <CountriesSection />
      <WhyChoose />
      <HowItWorks />
      <EligibilitySection />
      <StoriesSection />
      <StatsSection />
      <DocChecklist />
      <FaqSection />
      <BlogPreview />
      <ContactSection />
    </main>
  );
};

export default Home;
